import { ConverterOptions, ValueConverter } from '@shared/execution/types';
import { DataField } from '@shared/providers/types';
import * as QA from 'shared/utils/queryAnalysis';

export class SalesforceReportConverter implements ValueConverter {
  constructor() {}

  toProviderValue(value: any, field: DataField, options: ConverterOptions): any {
    return value;
  }

  toExcelValue(value: any, field: DataField, options: ConverterOptions): any {
    if (value?.length && QA.isSinglePicklistField(field.originalField)) {
      return `'${value}`;
    }
    return value;
  }
}
